<!-- Created by henian.xu on 2018/7/20. -->

<template>
    <page>
        <!-- 表单区 -->
        <template slot="secondHeader">
            <el-tabs
                class="classify-tabs"
                v-model="queryFormModel.customsClearanceStatus"
                type="card"
                @tab-click="onQuery()"
            >
                <el-tab-pane
                    label="全部"
                    name="0"
                />
                <el-tab-pane
                    label="报关中"
                    name="10"
                />
                <el-tab-pane
                    label="报关失败"
                    name="99"
                />
                <el-tab-pane
                    label="报关成功"
                    name="100"
                />
            </el-tabs>
            <el-form
                ref="queryForm"
                class="second-header npa-b"
                size="small"
                :inline="true"
                :model="queryFormModel"
            >
                <el-form-item
                    prop="orderSn"
                    label="订单号"
                >
                    <el-input
                        v-model="queryFormModel.orderSn"
                        placeholder="请输入订单号"
                    />
                </el-form-item>
                <el-form-item
                    prop="paymentSn"
                    label="付款单号"
                >
                    <el-input
                        v-model="queryFormModel.paymentSn"
                        placeholder="请输入付款单号"
                    />
                </el-form-item>
                <el-form-item
                    prop="externalPaymentSn"
                    label="付款流水号"
                >
                    <el-input
                        v-model="queryFormModel.externalPaymentSn"
                        placeholder="请输入付款流水号"
                    />
                </el-form-item>
                <el-form-item
                    prop="paymentType"
                    label="付款方式"
                >
                    <dictionaries-picker
                        type="paymentType"
                        v-model="queryFormModel.paymentType"
                        :clearable="false"
                    />
                </el-form-item>
                <el-form-item
                    prop="certCheckResult"
                    label="身份认证结果"
                >
                    <el-select
                        v-model="queryFormModel.certCheckResult"
                        placeholder="请选择"
                    >
                        <el-option
                            label="全部"
                            value=""
                        />
                        <el-option
                            label="未上传"
                            value="1"
                        />
                        <el-option
                            label="身份信息一致"
                            value="2"
                        />
                        <el-option
                            label="身份信息不一致"
                            value="3"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="onQuery()"
                    >
                        查询
                    </el-button>
                    <el-button
                        type="success"
                        @click="onReset"
                    >
                        重置
                    </el-button>
                </el-form-item>
            </el-form>
        </template>

        <!-- 内容 -->
        <div
            class="body"
            slot="body"
            v-loading="querying"
        >
            <!-- 操作 -->
            <div
                class="ma-b"
            >
                <el-button-group>
                    <el-button
                        type="danger"
                        icon="el-icon-delete"
                        size="small"
                        @click="onRePush"
                        :disabled="!currentTableSelect.length"
                    >
                        重新推送
                    </el-button>
                </el-button-group>
            </div>

            <!-- 表格 -->
            <el-table
                stripe
                border
                size="small"
                :data="tableData"
                style="width: 100%"
                @selection-change="onTableSelectionChange"
            >
                <el-table-column
                    type="selection"
                    width="36"
                />
                <el-table-column
                    prop="orderSn"
                    label="订单号"
                    width="120"
                />
                <el-table-column
                    prop="paymentSn"
                    label="付款单号"
                    min-width="100"
                />
                <el-table-column
                    prop="paymentTypeName"
                    label="付款方式"
                    width="80"
                />
                <el-table-column
                    prop="externalPaymentSn"
                    label="付款流水号"
                    min-width="100"
                />
                <el-table-column
                    prop="clearanceAmount"
                    label="报关金额"
                    width="80"
                />
                <!--                <el-table-column
prop="buyerName"
label="订购人姓名"
min-width="100"
/>
<el-table-column
prop="buyerIdNo"
label="订购人身份证"
min-width="100"
/>-->
                <el-table-column
                    prop="verifyDepartmentName"
                    label="验核机构"
                    width="80"
                />
                <el-table-column
                    prop="verifyDepartmentTradeId"
                    label="验核机构交易流水号"
                    min-width="100"
                />
                <el-table-column
                    prop="customsClearanceStatusName"
                    label="报关状态"
                    width="80"
                />
                <el-table-column
                    prop="customsClearanceResult"
                    label="报关结果"
                    min-width="100"
                />
                <el-table-column
                    prop="certCheckResult"
                    label="身份认证结果"
                    min-width="100"
                >
                    <template slot-scope="scope">
                        {{ scope.row.certCheckResult == 'SAME' || scope.row.certCheckResult == 'T' ? '身份信息一致' : scope.row.certCheckResult == 'DIFFERENT' || scope.row.certCheckResult == 'F' ? '身份信息不一致' : '未上传' }}
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="90"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="onTableEdit(scope.row)"
                            v-if="scope.row.customsClearanceStatus === 99"
                        >
                            重新推送
                        </el-button>
                        <el-button
                            type="text"
                            size="small"
                            @click="onSyncCustomsClearance(scope.row.id)"
                        >
                            查询结果
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="ma-t ta-r">
                <pagination
                    v-model="pagination"
                    @input="onQuery"
                />
            </div>
        </div>

        <!-- 弹框 -->
        <!-- 新增/编辑 -->
        <el-dialog
            :title="addDialog.formModel.id ? '编辑' : '新增'"
            center
            width="600px"
            :visible.sync="addDialog.isVisible"
            @closed="onAddDialogCancel"
        >
            <el-form
                ref="addForm"
                size="small"
                :model="addDialog.formModel"
                :rules="addDialog.formRules"
            >
                <el-form-item
                    prop="orderSn"
                    label="订单号"
                    label-width="6em"
                >
                    <el-input
                        v-model="addDialog.formModel.orderSn"
                        auto-complete="off"
                        disabled
                    />
                </el-form-item>
                <el-form-item
                    prop="paymentSn"
                    label="付款单号"
                    label-width="6em"
                >
                    <el-input
                        v-model="addDialog.formModel.paymentSn"
                        auto-complete="off"
                        disabled
                    />
                </el-form-item>
                <el-form-item
                    prop="paymentTypeName"
                    label="付款方式"
                    label-width="6em"
                >
                    <el-input
                        v-model="addDialog.formModel.paymentTypeName"
                        auto-complete="off"
                        disabled
                    />
                </el-form-item>
                <el-form-item
                    prop="externalPaymentSn"
                    label="付款流水号"
                    label-width="6em"
                >
                    <el-input
                        v-model="addDialog.formModel.externalPaymentSn"
                        auto-complete="off"
                        disabled
                    />
                </el-form-item>
                <el-form-item
                    prop="clearanceAmount"
                    label="报关金额"
                    label-width="6em"
                >
                    <el-input-number
                        controls-position="right"
                        :min="0"
                        :precision="2"
                        v-model.number="addDialog.formModel.clearanceAmount"
                    />
                </el-form-item>
                <el-form-item
                    prop="customsPlace"
                    label="海关编号"
                    label-width="6em"
                >
                    <el-input
                        v-model="addDialog.formModel.customsPlace"
                        auto-complete="off"
                    />
                </el-form-item>
                <el-form-item
                    prop="merchantCustomsName"
                    label="商户海关备案名称"
                    label-width="6em"
                >
                    <el-input
                        v-model="addDialog.formModel.merchantCustomsName"
                        auto-complete="off"
                    />
                </el-form-item>
                <el-form-item
                    prop="merchantCustomsCode"
                    label="商户海关备案编号"
                    label-width="6em"
                >
                    <el-input
                        v-model="addDialog.formModel.merchantCustomsCode"
                        auto-complete="off"
                    />
                </el-form-item>
                <!--                <el-form-item
prop="buyerName"
label="订购人姓名"
label-width="6em"
>
<el-input
v-model="addDialog.formModel.buyerName"
auto-complete="off"
/>
</el-form-item>
<el-form-item
prop="buyerIdNo"
label="订购人身份证号"
label-width="6em"
>
<el-input
v-model="addDialog.formModel.buyerIdNo"
auto-complete="off"
/>
</el-form-item>-->
            </el-form>
            <div
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    type="primary"
                    size="small"
                    @click="onAddDialogConfirm"
                >
                    确 定
                </el-button>
                <el-button
                    size="small"
                    @click="onAddDialogCancel"
                >
                    取 消
                </el-button>
            </div>
        </el-dialog>
    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';
import { queryFormList } from 'vmf/src/mixins';

export default {
    name: 'Variable',
    mixins: [pagesMixin, queryFormList],
    data() {
        return {
            queryFormModel: {
                customsClearanceStatus: '',
                orderSn: '',
                paymentSn: '',
                externalPaymentSn: '',
                paymentType: '',
                certCheckResult: '',
            },
            // 新增/编辑
            addDialog: {
                // 对话框显示
                isVisible: false,
                // 表单数据
                formModel: {
                    id: '',
                    orderSn: '',
                    paymentSn: '',
                    paymentTypeName: '',
                    externalPaymentSn: '',
                    clearanceAmount: '',
                    customsPlace: '',
                    merchantCustomsName: '',
                    merchantCustomsCode: '',
                    buyerName: '',
                    buyerIdNo: '',
                },
                // 表单校验规则
                formRules: {
                    clearanceAmount: {
                        required: true,
                        message: '请输入报关金额',
                        trigger: 'blur',
                    },
                    customsPlace: {
                        required: true,
                        message: '请输入海关编号',
                        trigger: 'blur',
                    },
                    merchantCustomsName: {
                        required: true,
                        message: '请输入商户海关备案名称',
                        trigger: 'blur',
                    },
                    merchantCustomsCode: {
                        required: true,
                        message: '请输入商户海关备案编号',
                        trigger: 'blur',
                    },
                },
            },
            // 表格数据
            tableData: [],
            // 表格当前选中行
            currentTableSelect: [],
        };
    },
    methods: {
        /* -- 方法 -- */
        // 请求列表数据
        getListData(queryData) {
            return this.$api.Ex.CustomsClearance.data(queryData).then(json => {
                const res = json.data;
                this.tableData = res.data;
                this.pagination = res.pagination;
                return Promise.resolve(json);
            });
        },
        /* -- 事件 -- */
        onAdd() {
            this.addDialog.isVisible = true;
            this.$nextTick(() => {
                const { addForm } = this.$refs;
                addForm.resetFields();
                const { formModel } = this.addDialog;
                formModel.id = '';
            });
        },
        onTableSelectionChange(val) {
            this.currentTableSelect = val;
        },
        onTableEdit(row) {
            const { formModel } = this.addDialog;
            this.$api.Ex.CustomsClearance.getDetail({ id: row.id }).then(json => {
                const res = json.data.data;
                this.$utils.formModelMerge(formModel, res);
            });
            this.addDialog.isVisible = true;
        },
        onTableDelete(ids) {
            this.$confirm('是否确定要重推！', '温馨提示', {
                type: 'warning',
            }).then(() => {
                this.$api.Ex.CustomsClearance.rePush({ ids }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.onQuery(this.pagination);
                });
            });
        },
        onSyncCustomsClearance(id) {
            this.$confirm('是否重新查询结果！', '温馨提示', {
                type: 'warning',
            }).then(() => {
                this.$api.Ex.CustomsClearance.syncCustomsClearance({ ids: id }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.onQuery(this.pagination);
                });
            });
        },
        onRePush() {
            const ids = this.currentTableSelect.reduce((prev, next) => {
                prev.push(next.id);
                return prev;
            }, []);
            this.onTableDelete(ids.join(','));
        },
        onAddDialogConfirm() {
            const { addForm } = this.$refs;
            addForm.validate().then(() => {
                this.$api.Ex.CustomsClearance.save({
                    ...this.addDialog.formModel,
                }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.onQuery(this.pagination);
                    this.addDialog.isVisible = false;
                });
            });
        },
        onAddDialogCancel() {
            const { addForm } = this.$refs;
            addForm.resetFields();
            const { formModel } = this.addDialog;
            formModel.id = '';
            this.addDialog.isVisible = false;
        },
    },
};
</script>

<style lang="scss">
</style>
